"use client";

import { Button } from "@/components/ui/button";
export default function HeroOverview() {
  return <section data-section-id="257902" id="hero" className="relative w-full min-h-[72vh] bg-cover bg-center !bg-[url(https://stable-woodcock.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-16-2026-10_18_05-AM.png)] flex items-center justify-center bg-background text-foreground overflow-hidden">
      <div className="absolute inset-0 bg-primary-900/65" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/30 via-primary-900/45 to-primary-950/75" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-24 text-center">
        <div className="max-w-5xl mx-auto">
          <div className="inline-flex items-center justify-center px-4 py-2 mb-6 rounded-full bg-white/10 border border-white/20 text-white/90 text-sm font-default tracking-wide">
            Career Opportunities
          </div>

          <h1 className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight leading-tight">
            Meaningful work, real balance, and room to grow.
          </h1>

          <p className="font-default text-lg sm:text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            RiverBend offers a different kind of professional career: practical,
            solutions-based work, no reliance on overtime, no tax-season crunch,
            and the chance to help clients and communities move important work
            forward.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-4xl mx-auto mb-10 text-left">
          <div className="bg-white/10 border border-white/20 rounded-2xl p-5 backdrop-blur-sm shadow-sm">
            <p className="font-default text-white font-semibold text-base mb-2">
              Work-life balance
            </p>

            <p className="font-default text-white/80 text-sm leading-relaxed">
              We are building around sustainable workloads, clear priorities,
              and respect for life outside work.
            </p>
          </div>

          <div className="bg-white/10 border border-white/20 rounded-2xl p-5 backdrop-blur-sm shadow-sm">
            <p className="font-default text-white font-semibold text-base mb-2">
              Creative client work
            </p>

            <p className="font-default text-white/80 text-sm leading-relaxed">
              Bring ideas, solve real problems, and help build practical systems
              that clients can use.
            </p>
          </div>

          <div className="bg-white/10 border border-white/20 rounded-2xl p-5 backdrop-blur-sm shadow-sm">
            <p className="font-default text-white font-semibold text-base mb-2">
              Real impact
            </p>

            <p className="font-default text-white/80 text-sm leading-relaxed">
              Work with people and organizations where your effort supports
              better decisions and long-term progress.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button type="button" variant="default" size="lg" onClick={() => {
          const opportunitiesSection = document.getElementById("current-opportunities");
          if (opportunitiesSection) {
            opportunitiesSection.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          } else {
            window.location.href = "/career-opportunities/";
          }
        }} className="bg-secondary-500 text-white hover:bg-secondary-600 font-semibold px-8 py-3 rounded-md shadow-md">
            View Current Opportunities
          </Button>

          <Button type="button" variant="outline" size="lg" onClick={() => {
          window.location.href = "/our-commitment-to-employees/";
        }} className="bg-white/10 text-white border-white/40 hover:bg-white/20 hover:text-white font-semibold px-8 py-3 rounded-md">
            Our Commitment to Employees
          </Button>
        </div>
      </div>
    </section>;
}